import { render, staticRenderFns } from "./distancia.vue?vue&type=template&id=a8819b22&scoped=true"
import script from "./distancia.vue?vue&type=script&lang=js"
export * from "./distancia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8819b22",
  null
  
)

export default component.exports